const globalScripts = () => {};

export { globalScripts as g };
